import { DISCOVER_LOAD_MORE_SKELETON_COUNT } from './discover.constants';

export const buildPersonFeedItem = (profile, keySuffix = '') => ({
	type: 'person',
	profile,
	key: keySuffix ? `${profile._id}${keySuffix}` : profile._id,
});

export const buildPersonFeedItems = (persons, keySuffix = '') =>
	persons.map((profile) => buildPersonFeedItem(profile, keySuffix));

export const buildSkeletonFeedItems = (prefix) =>
	Array.from({ length: DISCOVER_LOAD_MORE_SKELETON_COUNT }, (_, index) => ({
		type: 'skeleton',
		key: `${prefix}-skeleton-${index}`,
	}));

export const getLastPersonDomIndex = (items) => {
	for (let index = items.length - 1; index >= 0; index -= 1) {
		if (items[index]?.type === 'person') {
			return index;
		}
	}

	return -1;
};

export const resolveNextLoadedPersons = (persons, startIndex) => {
	const loaded = [];

	for (let index = 0; index < DISCOVER_LOAD_MORE_SKELETON_COUNT; index += 1) {
		const catalogIndex = (startIndex + index) % persons.length;
		const profile = persons[catalogIndex];
		loaded.push(
			buildPersonFeedItem(profile, `-append-${startIndex + index}`),
		);
	}

	return loaded;
};
